import { render, staticRenderFns } from "./GestionesPage.vue?vue&type=template&id=30a2d550"
import script from "./GestionesPage.js?vue&type=script&lang=js&external"
export * from "./GestionesPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports